import { FormHelperText } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { Button, RelodeTheme } from "../";
import { PlusIcon } from "../../assets/icons";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {},
            uploadButton: {
                margin: `${theme.spacing(2)}px 0`,
                display: "inline-flex",
            },
            uploadIcon: {
                marginRight: theme.spacing(1),
            },
            uploadInput: {
                display: "none",
            },
            message: {
                width: 360,
                alignSelf: "center",
                marginTop: theme.spacing(2),
            },
        }),
    { name: "Upload" }
);

interface UploadProps {
    className?: string;
    dataCy?: string;
    baseId: string;
    buttonText?: string;
    disableButton?: boolean;
    allowedFileTypes?: string;
    uploadErrorMessage?: string;
    onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export const Upload = (props: UploadProps) => {
    const classes = useStyles({});
    const {
        className,
        dataCy,
        baseId,
        buttonText = "attachment",
        disableButton = false,
        allowedFileTypes,
        uploadErrorMessage,
        onUpload,
    } = props;
    const rootClasses = classnames(classes.root, className);
    const [acceptedExtensions, setAcceptedExtensions] = React.useState<string>();

    React.useEffect(() => {
        if (!!allowedFileTypes) {
            setAcceptedExtensions(allowedFileTypes);
        } else {
            setAcceptedExtensions(".doc,.docx,.pdf,.rtf,.txt,.xls,.xlsx,.jpeg,.jpg,.png,.gif,.zip,.m4s,.mp3,"
            + ".ogg,.wav,.wma,.3gp,.avi,.flv,.m2v,.m4p,.m4v,.mkv,.mov,.mp2,.mp4,.mpa,.mpe,.mpeg,.mpg,.mpv,.ogv,"
            + ".webm,.wmv");
        }
    }, [baseId, allowedFileTypes]);

    return (
        <div className={rootClasses} data-cy={dataCy}>
            <input
                accept={acceptedExtensions}
                className={classes.uploadInput}
                id={`${baseId}Input`}
                type="file"
                value=""
                onChange={onUpload}
                name={`${baseId}FileInput`}
            />
            <label htmlFor={`${baseId}Input`}>
                <Button
                    id={`${baseId}UploadButton`}
                    color="default"
                    variant="contained"
                    size="small"
                    component="span"
                    className={classes.uploadButton}
                    title={`upload ${buttonText || "attachment"}`}
                    disabled={disableButton}
                >
                    <PlusIcon className={classes.uploadIcon} /> {buttonText}
                </Button>
            </label>
            {!!uploadErrorMessage && (
                <div className={classes.message}>
                    <FormHelperText error>{uploadErrorMessage}</FormHelperText>
                </div>
            )}
        </div>
    );
};
